import { c as _c } from "react/compiler-runtime";
import styles from '@/app/lcv/components/sections/spartan/products/engine/styles.module.css';
export const SpartanProductEngineStageGradient = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className={styles.stageFill} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};